import React, { ReactEventHandler } from 'react';
import { Modal, SwipeableDrawer } from '@mui/material';
import Wrapper from './styles';
import UiCloseButton from '../close-button/UiCloseButton';
import { filterStyleProps } from '../../../styles/utils';
import { UiModalProps } from '../../../types/components/global-modal/types';

export default function UiModal(props: UiModalProps) {
    const {
        open = true,
        children,
        onClose = () => {},
        onOpen = () => {},
        mode = 'default',
        icon,
        shouldDisplayCloseButton = true,
        title,
        disableEnforceFocus = false,
        disableBackdropClick,
        disableEscapeKeyDown,
    } = props;
    const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

    function handleOnClose(_, reason: 'backdropClick' | 'escapeKeyDown') {
        if (disableBackdropClick && reason === 'backdropClick') {
            return;
        }
        if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
            return;
        }
        onClose();
    }

    if (mode === 'drawer') {
        return (
            <SwipeableDrawer
                open={open}
                onClose={handleOnClose as ReactEventHandler}
                anchor="bottom"
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                disableSwipeToOpen={true}
                onOpen={onOpen}
                PaperProps={{
                    sx: {
                        '&&': {
                            backgroundColor: 'var(--surface-level-2-bg)',
                        },
                        backgroundImage: 'none',
                        ...props.paperProps,
                    },
                }}
            >
                <Wrapper {...filterStyleProps(props)} $mode={mode}>
                    <div className="cutout">
                        <div className="holder" />
                    </div>
                    {onClose && shouldDisplayCloseButton && (
                        <UiCloseButton onClick={onClose} className="new-close-button" />
                    )}
                    {icon && <div className="ui-modal-icon">{icon}</div>}
                    {title && <div className="ui-modal-title">{title}</div>}
                    {open && children && <div className="ui-modal-content">{children}</div>}
                </Wrapper>
            </SwipeableDrawer>
        );
    } else {
        return (
            <Modal open={open} onClose={handleOnClose} disableEnforceFocus={disableEnforceFocus}>
                <Wrapper {...filterStyleProps(props)} $mode={mode}>
                    {onClose && shouldDisplayCloseButton && (
                        <UiCloseButton onClick={onClose} className="new-close-button" />
                    )}
                    {icon && <div className="ui-modal-icon">{icon}</div>}
                    {title && <div className="ui-modal-title">{title}</div>}
                    {children && <div className="ui-modal-content">{children}</div>}
                </Wrapper>
            </Modal>
        );
    }
}
